<template>
  <div id="container">
    <header class="header custom-bg clearfix">
      <div class="custom-contact">
        客服电话：{{ cs_tel }}
      </div>
      <div class="logo">
        <!--        <a href="http://www.sritranggroup.com"><img src="../assets/images/logo1.png" alt=""></a>-->
        <!--        <a href="http://www.sritranggloves.com/zh"><img src="../assets/images/logo2.png" alt=""></a>-->
        <a :href="item.jumpUrl" v-for="(item,index) in linkBannerlist" :key="index"><img :src="item.url" alt=""></a>
      </div>
      <div class="top-navigation">
        <el-menu
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#95c93d"
            :default-active="$route.fullPath"
            :router="true">
          <el-menu-item index="/index">首页</el-menu-item>
          <el-submenu index="2">
            <template #title>关于诗董</template>
            <el-menu-item index="/group-introduction">集团介绍</el-menu-item>
            <el-menu-item index="/history">发展历史</el-menu-item>
            <el-menu-item index="/awards">荣誉奖项</el-menu-item>
            <el-menu-item index="/about">诗董中国</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template #title>绿色橡胶</template>
            <el-menu-item index="/business-introduction">业务介绍</el-menu-item>
            <el-menu-item index="/rubber-products">关于诗董</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template #title>健康手套</template>
            <el-menu-item index="/product/introduction">业务概况</el-menu-item>
            <el-menu-item index="/glove/category">手套分类</el-menu-item>
            <el-menu-item index="/shiruikang">品牌系列</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template #title>新闻中心</template>
            <el-menu-item index="/news/company">公司新闻</el-menu-item>
            <el-menu-item index="/news/product">橡胶资讯</el-menu-item>
            <el-menu-item index="/news/rubber">手套资讯</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact-us">联系我们</el-menu-item>
        </el-menu>
      </div>
    </header>
    <main>
      <router-view/>
    </main>
    <footer>
      <div class="bottom-left">
        <p>{{ copyright }}</p>
      </div>
      <div class="bottom-right">
        <p>诗董中国</p>
        <p>{{ address }}</p>
        <p>SRITRANG</p>
      </div>
    </footer>
  </div>
</template>
<script>
import {getContactusIndex} from "@/api/api";

export default {
  name: 'Layout',
  data() {
    return {
      email: '',
      address: '',
      glove_email: '',
      rubber_email: '',
      cs_tel: '',
      copyright: '',
      linkBannerlist: null,
    }
  },
  created() {
    this.getContactus();
  },
  methods: {
    getContactus() {
      getContactusIndex().then((res) => {
        this.email = res.data.email;
        this.address = res.data.address;
        this.glove_email = res.data.glove_email;
        this.rubber_email = res.data.rubber_email;
        this.cs_tel = res.data.cs_tel;
        this.copyright = res.data.copyright;
        this.linkBannerlist = res.data.linkBannerlist;
      });
    },
  }
}
</script>
<style scoped>
@import url("Index.css");
</style>
